import { Plus, X } from "lucide-react";
import { usePlayground } from "../../contexts/PlaygroundContext";
import { MAX_SELECTED_MODELS } from "./types";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export default function ModelSelector() {
    const { state, addModel, removeModel, setSelectedModels } = usePlayground();

    const isComparePrompts = state.mode === 'compare-prompts';

    const availableToAdd = state.availableModels.filter(
        (model) => !state.selectedModels.includes(model)
    );

    const handleAddModel = (modelId: string) => {
        if (modelId) {
            if (isComparePrompts) {
                setSelectedModels([modelId]);
            } else {
                addModel(modelId);
            }
        }
    };

    const handleRemoveModel = (modelId: string) => removeModel(modelId);

    const maxModels = isComparePrompts ? 1 : MAX_SELECTED_MODELS;
    const canAddMore = isComparePrompts || state.selectedModels.length < maxModels;
    const hasModelsToAdd = availableToAdd.length > 0;

    const label = isComparePrompts ? 'Modelo' : 'Modelos para comparar';
    const helpText = isComparePrompts
        ? 'Selecione um modelo para comparar prompts'
        : 'Selecione pelo menos um modelo para começar';

    return (
        <div className="space-y-3">
                <p className="text-[13px] font-semibold text-foreground">{label}</p>
                <div className="flex flex-wrap items-center gap-2">
                    {state.selectedModels.map((modelId) => (
                        <span
                            key={modelId}
                            className="inline-flex items-center gap-1.5 rounded-md border border-primary/30 bg-primary/5 px-2 py-1 text-xs font-medium text-primary"
                        >
                            {modelId}
                            {!isComparePrompts && (
                                <button
                                    type="button"
                                    onClick={() => handleRemoveModel(modelId)}
                                    disabled={state.isGenerating}
                                    aria-label={`Remover ${modelId}`}
                                    className="rounded text-primary/70 hover:text-primary hover:bg-primary/10"
                                >
                                    <X className="h-3.5 w-3.5" />
                                </button>
                            )}
                        </span>
                    ))}
                    {canAddMore && (
                        <Select value="" onValueChange={handleAddModel} disabled={state.isGenerating || !hasModelsToAdd}>
                            <SelectTrigger aria-label={isComparePrompts ? "Trocar modelo" : "Adicionar modelo"} className="h-10 min-w-[220px] w-auto gap-2 text-sm">
                                <div className="inline-flex items-center gap-1.5 text-muted-foreground">
                                    <Plus className="h-4 w-4 shrink-0" />
                                    <span>
                                        {hasModelsToAdd
                                            ? (isComparePrompts ? "Trocar modelo" : "Adicionar modelo")
                                            : "Carregando..."}
                                    </span>
                                </div>
                                <SelectValue />
                            </SelectTrigger>
                            <SelectContent>
                                {availableToAdd.map((m) => (
                                    <SelectItem key={m} value={m}>{m}</SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    )}
                </div>
                {state.selectedModels.length === 0 && (
                    <p className="text-xs italic text-muted-foreground">{helpText}</p>
                )}
            </div>
    );
}
